// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"52fba09a","998":"7ae496c6"}[chunkId] + ".chunk.css";
};